import { useQuery } from '@tanstack/react-query';

import { intercultureQueries } from '../../data-access/queries/interculture';

import { useFiltersStore, useQueriesWithGlobal } from '@data-access';

interface Params {
  type: string;
}

export function useIntercultureForms({ type }: Params) {
  const page = useFiltersStore.use['interculture']().pagination.pageIndex + 1;
  const sorting = useFiltersStore.use['interculture']().sorting;
  const filters = useFiltersStore.use['interculture']().filters;

  const queries = useQueriesWithGlobal(intercultureQueries);

  const query = useQuery(
    queries.list({
      crop: type,
      filters: { filters, page, sorting },
    }),
  );

  return query;
}

export default useIntercultureForms;
